import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { CareProgramTemplateDated1lvcdu3xhc5up as CareProgramTemplateDated } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_price2xrsb653e7yz0 as get_price,
  get_transportOneWay2b2salmzx1v85 as get_transportOneWay,
  get_transportTwoWay1ju1bbhgmnodz as get_transportTwoWay,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { lensPath21i5dxhjzuxep as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { datePeriodInput2rxrzbjjw21rh as datePeriodInput } from '../components/datePeriodInput.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CareProgramTemplateDatedForm(form, _this__u8e3s4, version, heading) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => heading($this$invoke));
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  var tmp_2 = CareProgramTemplateDatedForm$lambda;
  var tmp_3 = CareProgramTemplateDatedForm$lambda_0;
  form.dateField$default_ksnshl_k$(element, tmp_2, version.lens_u4wb4z_k$(tmp_3, CareProgramTemplateDatedForm$lambda_1), true);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_rem(40);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowCollapsingToColumn())(element.get_context_h02k06_k$(), listOf(new (Dimension())(breakpoint)));
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp_4 = weight(element_1, 1.0);
  var tmp_5 = CareProgramTemplateDatedForm$lambda_2;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_6 = serializerOrContextual(createKType(getKClass(CareProgramTemplateDated()), arrayOf([]), false));
  var tmp$ret$17 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$17);
  var tmp$ret$18 = get_price(it);
  var tmp$ret$15 = lensPath(version, tmp$ret$18);
  form.priceInput$default_xy5xas_k$(tmp_4, tmp_5, tmp$ret$15, true);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp_7 = weight(element_1, 1.0);
  var tmp_8 = CareProgramTemplateDatedForm$lambda_3;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_9 = serializerOrContextual(createKType(getKClass(CareProgramTemplateDated()), arrayOf([]), false));
  var tmp$ret$22 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$22);
  var tmp$ret$23 = get_transportOneWay(it_0);
  var tmp$ret$20 = lensPath(version, tmp$ret$23);
  form.priceInput$default_xy5xas_k$(tmp_7, tmp_8, tmp$ret$20);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  var tmp_10 = weight(element_1, 1.0);
  var tmp_11 = CareProgramTemplateDatedForm$lambda_4;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_12 = serializerOrContextual(createKType(getKClass(CareProgramTemplateDated()), arrayOf([]), false));
  var tmp$ret$27 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$27);
  var tmp$ret$28 = get_transportTwoWay(it_1);
  var tmp$ret$25 = lensPath(version, tmp$ret$28);
  form.priceInput$default_xy5xas_k$(tmp_10, tmp_11, tmp$ret$25);
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function ageRangeFields(_this__u8e3s4, ageStart, ageEnd) {
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_rem(50);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowCollapsingToColumn())(_this__u8e3s4.get_context_h02k06_k$(), listOf(new (Dimension())(breakpoint)));
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_0 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  var tmp = KMutableProperty0();
  var tmp_0 = LabeledView$_get_content_$ref_5yojet(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, LabeledView$_set_content_$ref_ys1c8f(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ageRangeFields$lambda);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$7 = themed(element_0, FieldSemantic_getInstance());
  datePeriodInput(tmp$ret$7, ageStart);
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = LabeledView$_get_content_$ref_5yojet(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, LabeledView$_set_content_$ref_ys1c8f(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ageRangeFields$lambda_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$12 = themed(element_1, FieldSemantic_getInstance());
  datePeriodInput(tmp$ret$12, ageEnd);
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function CareProgramTemplateDatedForm$lambda($this$dateField) {
  return $this$dateField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateInForceFromLabel_hamky5_k$();
}
function CareProgramTemplateDatedForm$lambda_0(it) {
  return it.activeRange_1.start_1;
}
function CareProgramTemplateDatedForm$lambda_1(old, new_0) {
  return old.copy$default_7ear6o_k$(VOID, VOID, old.activeRange_1.copy$default_iikz6e_k$(new_0 == null ? old.activeRange_1.start_1 : new_0));
}
function CareProgramTemplateDatedForm$lambda_2($this$priceInput) {
  return $this$priceInput.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateDailyRateColumnLabel_3eflwu_k$();
}
function CareProgramTemplateDatedForm$lambda_3($this$priceInput) {
  return $this$priceInput.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportOneWayLabel_hbgejv_k$();
}
function CareProgramTemplateDatedForm$lambda_4($this$priceInput) {
  return $this$priceInput.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateTransportTwoWayLabel_x99pbj_k$();
}
function ageRangeFields$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateAgeStartLabel_lia3xk_k$();
}
function ageRangeFields$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateAgeEndLabel_j1qosv_k$();
}
//region block: exports
export {
  CareProgramTemplateDatedForm as CareProgramTemplateDatedForm1ksxay8oqics6,
  ageRangeFields as ageRangeFieldsprqneuhkkp7o,
};
//endregion

//# sourceMappingURL=rateComponents.mjs.map
